import { ACTION_TYPES, useAuditSearchDispatch, useAuditSearchState } from './audit-search-context';
import AuditAppService from '../../../../application/platform/apm/audit/audit-app-service';
import { IAuditResponse } from '../../../../model/apm/audit/response/audit-response';
import { IAuditAddEditRequest } from '../../../../model/apm/audit/request/audit-add-edit-request';
import { IAuditPagedRequest } from '../../../../model/apm/audit/request/audit-paged-request';
import { parseNumberInput } from '../../../../utils/format';
import { useActionRunner } from '../../../../hooks/use-action-runner';
import { useSearchActions } from '../../../../hooks/use-search-actions';
import { parseIdFilter } from '../../../../utils/filter-options';

export const useAuditSearchController = () => {
    const dispatch = useAuditSearchDispatch();
    const state = useAuditSearchState();
    const { isSaving, runSaving, run, showSuccess, confirmDelete } = useActionRunner();
    const { updateParameters, triggerSearch, ...searchHandlers } = useSearchActions<IAuditPagedRequest>(
        dispatch, ACTION_TYPES, { term: undefined, year: undefined, status: undefined, inspectionBody: undefined },
    );

    function handleOnChange(e: any) {
        const { name, value } = e.target;
        if (name === 'input-term') updateParameters({ term: value || undefined });
        if (name === 'input-year') updateParameters({ year: parseNumberInput(value) });
        if (name === 'select-status') updateParameters({ status: parseIdFilter(value) });
        if (name === 'select-inspection-body') updateParameters({ inspectionBody: parseIdFilter(value) });
    }

    // A listagem já traz a auditoria completa
    function openDrawer(row?: IAuditResponse) {
        dispatch({ type: ACTION_TYPES.openDrawer, payload: row });
    }

    function closeDrawer() {
        dispatch({ type: ACTION_TYPES.closeDrawer });
    }

    function handleSave(request: IAuditAddEditRequest) {
        const editing = state.drawer.audit;
        return runSaving('Não foi possível salvar a auditoria', async () => {
            await (editing ? AuditAppService.edit(editing.id, request) : AuditAppService.add(request));
            showSuccess(editing ? 'Auditoria atualizada com sucesso!' : 'Auditoria cadastrada com sucesso!');
            closeDrawer();
            triggerSearch();
        });
    }

    function handleDelete(row: IAuditResponse) {
        confirmDelete(`Tem certeza que deseja excluir a auditoria do processo "${row.processNumber}"?`, () => run('Não foi possível excluir a auditoria', async () => {
            await AuditAppService.remove(row.id);
            showSuccess('Auditoria excluída com sucesso!');
            triggerSearch();
        }));
    }

    return {
        isSaving,
        handleOnChange, ...searchHandlers,
        openDrawer, closeDrawer, handleSave, handleDelete,
    };
};
